export function appendPeriodIfMissing(error: string) {
  const endsWithDot = error.endsWith('.');

  return error + (endsWithDot ? '' : '.');
}

export function startCase(text: string = '') {
  return (
    text
      // Insert a space before each uppercase letter (unless it's at the start)
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      // Split by spaces, underscores, or any whitespace
      .split(/[\s_]+/)
      // Capitalize the first letter of each word and lowercase the rest
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      // Join the words with a space
      .join(' ')
  );
}

export function getPastTense(text: string) {
  if (!text) return '';

  if (text === 'Pending') return text;

  if (text.toLocaleLowerCase() === 'open') {
    return text;
  }

  if (text.endsWith('ing')) {
    return text.replace(/ing$/, 'ed');
  }
  if (text.endsWith('e')) {
    return text.replace(/e$/, 'ed');
  }
  return `${text}ed`;
}

export function kebabCase(text: string) {
  return String(text).toLowerCase().replace(/ /g, '-');
}

export function capitalizeFirst(text?: string): string {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1);
}
